import React, { useContext } from "react";
import { renderCount } from "../../../appHelpers/appLoggers";
import styled from "styled-components";
import { MobileSidebarToggleFC } from "./MobileDisplayToggleFC";
import { DarkModeContext } from "../../../appContexts/DarkModeContext";
import { AvanteLogoFC } from "./AvanteLogoFC";
import { AuthBtnFC } from "../../../auth/AuthBtnFC";
import Profile from "../../../auth/Profile";

export const _HeaderFC = () => {
  // renderCount(`./components/main/header/_HeaderFC`);

  const { darkMode } = useContext(DarkModeContext);

  return (
    <HeaderSC darkMode={darkMode}>
      <LeftSection>
        <MobileSidebarToggleFC />
      </LeftSection>
      <CenterSection>
        <AvanteLogoFC />
      </CenterSection>
      <RightSection>
        <Profile />
      </RightSection>
    </HeaderSC>
  );
};

const HeaderSC = styled.header`
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;

  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 250, 252, 0.98) 100%
  );
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);

  border-bottom: 1px solid rgba(44, 90, 160, 0.1);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);

  /* Hide on desktop since top nav handles everything */
  @media screen and (min-width: 769px) {
    display: none;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
`;

const CenterSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
`;
